import { PropsWithChildren, useEffect } from "react";
import {
  Controller,
  FieldPath,
  FieldValues,
  Path,
  PathValue,
  UseFormReturn,
} from "react-hook-form";
import { BaseFieldProps } from "./BaseField";

export interface HiddenFieldProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>
> extends BaseFieldProps<TFieldValues, TName> {
  onChange?: (value: string) => void;
  valueState?: PathValue<TFieldValues, Path<TFieldValues>>;
  defaultValue?: number | string | boolean;
  form: UseFormReturn<TFieldValues>;
}
export function HiddenField<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>
>({
  name,
  defaultValue,
  form,
  onChange,
  valueState,
  rules,
}: PropsWithChildren<HiddenFieldProps<TFieldValues, TName>>) {
  useEffect(() => {
    if (valueState) {
      form.setValue(name, valueState);
      form.trigger(name);
    }
  }, [valueState, form, name]);
  return (
    <Controller
      name={name}
      control={form.control}
      defaultValue={defaultValue as PathValue<TFieldValues, TName> | undefined}
      rules={rules}
      render={({ field }) => (
        <input
          type="hidden"
          name={name}
          value={valueState || field.value}
          onChange={(e) => {
            field.onChange(e.target.value);
            onChange?.(e.target.value);
          }}
        />
      )}
    />
  );
}

HiddenField.defaultProps = {
  defaultValue: null,
};
